import {
  LOCALIDAD_ERROR,
  LOCALIDAD_SUCCESS,
  LOCALIDAD_LOADING,
  LOCALIDAD_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import localidadInitialState from "../initialStates/localidadInitialState";

const localidad = (state, { payload, type }) => {
  switch (type) {
    case LOCALIDAD_LOADING:
      return {
        ...state,
        localidad: {
          ...state.localidad,
          error: false,
          loading: true,
        },
      };
    case LOCALIDAD_SUCCESS:
      return {
        ...state,
        localidad: {
          ...state.localidad,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case LOCALIDAD_ERROR:
      return {
        ...state,
        localidad: {
          ...state.localidad,
          error: payload,
          loading: false,
        },
      };
    case LOCALIDAD_RESET:
      return localidadInitialState;
    case RESET_PORTAL_CONTEXT:
      return localidadInitialState;

    default:
      return state;
  }
};

export default localidad;
